import { render, staticRenderFns } from "./Debits.vue?vue&type=template&id=c2b11e9e"
import script from "./Debits.vue?vue&type=script&lang=js"
export * from "./Debits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports